import cn from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";

type LanguageSwitcherProps = {
  variant?: string;
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = "outline-primary" }) => {
  const { i18n, t } = useTranslation("layout");
  const languages: Array<{ code: "pl" | "en"; label: string }> = [
    { code: "pl", label: "PL" },
    { code: "en", label: "EN" }
  ];

  const handleChange = async (code: "pl" | "en") => {
    await i18n.changeLanguage(code);
  };

  return (
    <div
      className="btn-group"
      aria-label={t("footer.languageSwitcherLabel", { defaultValue: "Switch language" })}
      role="group"
    >
      {languages.map((language) => {
        const isActive = i18n.language === language.code;
        const buttonClass = cn("btn", isActive ? "btn-primary" : `btn-${variant}`);

        return (
          <button
            key={language.code}
            className={buttonClass}
            onClick={() => handleChange(language.code)}
            type="button"
            aria-pressed={isActive}
          >
            {language.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
